import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import PICDashboard from "../../organisms/Inventory/PICDashboard.tsx";
import { getPhysicalInventoryCountById } from "../../api/physicalInventoryCounts/index.ts";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PICDashboardScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [picData, setPicData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { openSnack } = useSnack();

  const fetchPICData = async () => {
    if (!id) return;
    try {
      setLoading(true);
      const response = await getPhysicalInventoryCountById(parseInt(id));
      setPicData(response.data);
    } catch (error) {
      openSnack(handleError(error), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPICData();
  }, [id]);

  const handleRefresh = () => {
    fetchPICData();
  };

  if (loading) {
    return (
      <DashboardLayout>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      </DashboardLayout>
    );
  }

  if (!picData) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Conteo físico no encontrado</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/inventory")}
            sx={{ mr: 2 }}
          >
            Volver
          </Button>
          <Typography variant="h5">
            Dashboard - Conteo Físico: {picData.code}
          </Typography>
        </Box>
        <Box sx={{ mt: 2 }}>
          <PICDashboard
            picId={picData.id}
            warehouseId={picData.warehouseId}
            companyId={picData.companyId}
            statusCode={picData.status?.code}
            onRefresh={handleRefresh}
          />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default PICDashboardScreen;

